module.exports = __webpack_public_path__ + "static/media/face_2_angry.43979da6.svg";